// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

type CourseReserveScope = {
   currentCount: any
   q?: string
   data: any,
   count: number,
   offset: number,
   page: number,
   limit: number,
   allLoaded: boolean,
   loading: boolean,
   headers: any[],
   loadedPagesMap: any,
   surplussOffset: number
}

type CourseReserve = {
   instructors: any[]
   display: any
   id: any
   name: any
   code: any
   section: any
   hidden?: boolean
   page: number
}

type CourseReserveDetailScope = {
   courseReserve: CourseReserve,
   docs: CourseReserve[],
   count: number,
   pn: number,
   ps: number
   allLoaded: boolean,
   loading: boolean
   isEndOfResults: any
}

class CourseReserveService {
   $http: angular.IHttpService
   $timeout: angular.ITimeoutService
   apiService: ApiService
   availability: AvailabilityService
   defaultDetailScope: CourseReserveDetailScope
   defaultScope: CourseReserveScope
   detailScope!: CourseReserveDetailScope
   fields: any
   scope!: CourseReserveScope
   utils: UtilitiesService
   resultsConfig: any
   constructor($http: any, $timeout: any, config: any, i18n: any, apiService: any, availability: any, utils: any) {
      this.setDefaultScope = this.setDefaultScope.bind(this)
      this.get = this.get.bind(this)
      this.filterResults = this.filterResults.bind(this)
      this.getCourseReserve = this.getCourseReserve.bind(this)
      this.setDefaultDetailScope = this.setDefaultDetailScope.bind(this)
      this.setDetailed = this.setDetailed.bind(this)
      this.getDetailDocs = this.getDetailDocs.bind(this)
      this.setAllLoaded = this.setAllLoaded.bind(this)
      this.areAllDetailLoaded = this.areAllDetailLoaded.bind(this)
      this.complementData = this.complementData.bind(this)
      this.handleFields = this.handleFields.bind(this)
      this.runSearch = this.runSearch.bind(this)
      this.runNewSearch = this.runNewSearch.bind(this)
      this.checkNewSearch = this.checkNewSearch.bind(this)
      this.$http = $http
      this.$timeout = $timeout
      this.apiService = apiService
      this.availability = availability
      this.utils = utils
      this.fields = config.data.alma.course_reserve_fields
      this.resultsConfig = config.data.results

      const headers: any[] = []
      const fieldMapping = {
         id() { return headers.push(i18n.translations.COURSE_ID) },
         description() { return headers.push(i18n.translations.DESCRIPTION) },
         instructor() { return headers.push(i18n.translations.INSTRUCTOR) },
         section() { return headers.push(i18n.translations.SECTION) }
      }
      this.handleFields(fieldMapping)

      this.defaultScope = {
         data: {},
         count: Infinity,
         currentCount: 0,
         offset: 0,
         limit: 20,
         page: 1,
         allLoaded: false,
         loading: false,
         headers,
         loadedPagesMap: {1:0},
         surplussOffset: 0
      }

      this.defaultDetailScope = {
         courseReserve: {} as CourseReserve,
         docs: [],
         count: Infinity,
         pn: 1,
         ps: this.resultsConfig.pageSize,
         allLoaded: false,
         loading: false,
         isEndOfResults: this.isEndOfResults.bind(this)
      }

      this.setDefaultScope()
      this.setDefaultDetailScope()
   }

   setDefaultScope() {
      if (!this.scope) { this.scope = {q: ''} as CourseReserveScope }
      return _.extend(this.scope, angular.copy(this.defaultScope))
   }

   calculateNextOffset(page: number) { 
      let highestLowerPage = 1;
      for(let i = 1; i < page; i++) {
         if(i in this.scope.loadedPagesMap) {
            highestLowerPage = i
         }
      }
      return (page - highestLowerPage) * this.scope.limit + this.scope.loadedPagesMap[highestLowerPage]
   }

   // SMN-4857 - Course Reserves Search Fails With Two or More Words
   // The issue was fixed in the Front end side. First we divide the whole term and perform Get over alma Api using the first word from that Term,
   // then we filter the results we got with the Whole term.
   // @ts-ignore FIXME type
   get(page?: number): angular.IHttpPromise {
      if (this.scope.loading || (this.scope.allLoaded && !page)) return
      this.scope.loading = true

      if(page && this.handlePageLoad(page)) return

      const { params, filterQuery } = this.createParams()
      return this.$http.get('/course_reserves', {params})
         .then((result: any): void => {
            let elems
            if (this.scope.offset === 0) {
               this.scope.count = result.data.count
            }
            this.scope.count -= result.data.reduce_count || 0
            // Checking filtered results. The code will always get <limit> results from the API, say 20.
            // But the API might return with only 18 results, since for example 2 are not <status>ACTIVE</status> and thus filtered
            // so keeping track of how many results there actually are
            this.scope.currentCount += _.keys(this.scope.data).length
            this.scope.loading = false
            if (filterQuery) {
               elems = this.filterResults(result, filterQuery)
            }
            this.hidePriorItems()
            const overflowed = this.complementData((elems != null) ? elems : result.data.course_reserves)
            this.showItemsForPage(this.scope.page)
            // Update for the next scroll get. Extra check when for some reason ALMA Api returned 0 records
            if ((this.scope.count < Infinity) && (this.scope.count > 0) && !((result.data.count === 0) && (this.scope.offset > 0))) {
               // When the page-size cap spills surplus ACTIVE courses onto the next page, register that
               // page (at the current batch offset, before updateOffsets advances it) so the spilled
               // courses stay reachable from cache instead of being paginated out and lost.
               const overflowPage = this.scope.page + 1
               if (overflowed && !(overflowPage in this.scope.loadedPagesMap)) {
                  this.scope.loadedPagesMap[overflowPage] = this.scope.offset
               }
               this.updateOffsets()
               // retrieve more until scope limit as been hit -- fills out the screen when 'ACTIVE' courses per request are minimal
               if ((result.data.count > 0) && (_.keys(this.scope.data).filter((c:any) => this.scope.data[c].page == this.scope.page).length < this.scope.limit)) {
                  this.lowerHigherPageNumbers()
                  // load next page from cache if possible
                  if(this.scope.loadedPagesMap[this.scope.page] > this.scope.offset - this.scope.limit){
                     this.setSurplussOffset()
                     this.loadFromCache(this.scope.page)
                     return
                  }
                  return this.get()
               }
               this.setSurplussOffset()
               this.setAllLoaded()
            }
         }).catch(() => {
            return this.scope.loading = false
         })
   }

   filterResults(result: any, filterQuery: any) {
      const filterTerms = filterQuery.split(' ')

      // FILTER LOGIC:
      // * combine name / code / instructors into a single string
      // * use filterTerms list to find matches
      // * single-term queries need ony 1 match
      // * multi-term queries need 1+ matches
      return _.filter(result.data.course_reserves, function(courseReserve: any) {
         let matches = 0
         let courseReserveFields: any = []
         courseReserveFields = courseReserveFields.concat(courseReserve.name.trim().toUpperCase().split(' '))
         courseReserveFields = courseReserveFields.concat(courseReserve.code.trim().toUpperCase().split(' '))
         const instructors = courseReserve.instructors.map((instructor: any) => instructor.full_name.trim().toUpperCase())
         instructors.forEach((instructorName: any) => courseReserveFields = courseReserveFields.concat(instructorName.split(' ')))
         const searchText = _.compact(courseReserveFields).join('')
         filterTerms.forEach(function(term: any) {
            const regex = new RegExp(term, 'ig')
            if (searchText.match(regex)) { return matches += 1 }
         })

         if (filterTerms.length !== 1) {
            return matches > 1
         } else {
            return matches >= 1
         }
      })
   }

   getCourseReserve(id: any, cb = angular.noop){
      if (this.scope.loading) { return }

      this.scope.loading = true

      return this.$http.get(`/course_reserves/${id}`)
         .then((result: any) => {
            this.complementData([result.data])
            this.scope.loading = false
            return cb()
         }).catch(() => { return this.scope.loading = false })
   }

   setDefaultDetailScope() {
      this.detailScope = this.detailScope || {}
      return _.extend(this.detailScope, angular.copy(this.defaultDetailScope))
   }

   setDetailed(id: any) : any {
      if (this.scope.data.hasOwnProperty(id)) {
         if (this.detailScope.courseReserve.id !== id) { this.setDefaultDetailScope() }
         _.extend(this.detailScope.courseReserve, angular.copy(this.scope.data[id]))
         return this.getDetailDocs()
      } else {
         this.setDefaultDetailScope()
         return this.getCourseReserve(id, () => this.setDetailed(id))
      }
   }

   getDetailDocs(page?:number) {
      if (this.detailScope.loading || (this.areAllDetailLoaded() && !page)) { return }
      if(page) { 
         this.detailScope.pn = page
         if(this.canLoadDetailsFromCache(page)) {
            this.loadDetailsFromCache(page)
            return
         }
      }
      const apiParams: any = _.pick(this.detailScope, 'pn', 'ps')
      const searchQueryAsArray = []

      const trimmedCode = this.detailScope.courseReserve.code.trim()
      const trimmedSection = this.detailScope.courseReserve.section?.trim()
      const searchQueryAsObject = {
         CourseName: this.detailScope.courseReserve.name.trim(),
         CourseCodeAndSection: trimmedSection ? trimmedCode + '.' + trimmedSection : trimmedCode
      }

      for (var paramName in searchQueryAsObject) {
         // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         var paramValue = searchQueryAsObject[paramName]
         searchQueryAsArray.push(`${paramName}:\"${paramValue}\"`)
      }
    
      apiParams.q = searchQueryAsArray.join(' AND ')

      this.detailScope.loading = true

      return this.apiService.courseReserves(apiParams).then((response: any) => {
         this.hidePriorDetails()
         if (response.data?.documents != null) {
            this.availability.getRTA(response.data.documents)
            _.each(response.data.documents, (doc: any, i: number) => {
               doc.hidden = false
               doc.index = i + 1 + this.detailScope.ps * (this.detailScope.pn - 1)
               return this.detailScope.docs.push(doc)
            })

            this.detailScope.count = response.data.record_count
            // Error loading from API
         } else {
            this.detailScope.count = 0
         }
         return this.detailScope.loading = false
      }).catch(() => {
         return this.detailScope.loading = false
      })
   }

   setAllLoaded() {
      this.scope.allLoaded = this.scope.offset >= this.scope.count 
   }

   areAllDetailLoaded() {
      return this.detailScope.allLoaded = this.detailScope.docs.length >= this.detailScope.count
   }

   isEndOfResults() {
      return this.detailScope.pn >= this.detailScope.count/this.detailScope.ps && !this.detailScope.loading
   }

   loadDetailsFromCache(page : number) {
      this.hidePriorDetails()
      this.showCurrentDetails(page)
   }

   hidePriorDetails() {
      this.detailScope.docs.forEach((doc: any) => doc.hidden = true)
   }

   showCurrentDetails(page : number) {
      const pageStart = (page - 1) * this.detailScope.ps + 1
      const pageEnd = pageStart + this.detailScope.ps - 1
      this.detailScope.docs.forEach((doc: any) => {
         if(doc.index >= pageStart && doc.index <= pageEnd) {
            doc.hidden = false
         }
      })
   }

   canLoadDetailsFromCache(page : number) {
      return this.detailScope.docs.find((doc: any) => doc.index === (page - 1) * this.detailScope.ps + 1)
   }

   updateOffsets() {
      // remember that this page has been loaded with given offset, we override lower offsets
      this.scope.loadedPagesMap[this.scope.page] = this.scope.offset
      // set up offset for next query
      this.scope.offset += this.scope.limit
   }

   setSurplussOffset() {
      const highestPage = Math.max(...Object.keys(this.scope.loadedPagesMap).map((p: string) => +p)) 
      const rawSurplus = this.scope.loadedPagesMap[highestPage] - (highestPage - 1) * this.scope.limit
      // Never discount more courses than the ones we have NOT yet cached. Otherwise already-loaded
      // (reachable) overflow courses would be paginated out of the result count and lost.
      const cachedCount = Object.keys(this.scope.data).length
      const maxDiscardable = Math.max(this.scope.count - cachedCount, 0)
      this.scope.surplussOffset = Math.min(rawSurplus, maxDiscardable)
   }

   handlePageLoad(page : number): boolean {
      let pageLoaded = false
      this.scope.offset = this.calculateNextOffset(page)
      this.scope.page = page
      if(page in this.scope.loadedPagesMap){
         this.loadFromCache(page)
         pageLoaded = true
      }
      return pageLoaded
   }

   createParams () {
      const params = _.pick(this.scope, 'offset', 'limit', 'q')
      const filterQuery = params.q?.trim()
      params.q = _.first( params.q?.split(' ') || [] )
      return { params, filterQuery }
   }

   loadFromCache(page: number){
      this.scope.offset = this.scope.loadedPagesMap[page] + this.scope.limit
      this.hidePriorItems()
      this.showItemsForPage(page)
      this.setAllLoaded()
      this.scope.loading = false
   }

   hidePriorItems(){
      for (let key in this.scope.data) {
         this.scope.data[key].hidden = true
      }
   }

   showItemsForPage(page:number) {
      for (let key in this.scope.data) {
         if(this.scope.data[key].page === page) {
            this.scope.data[key].hidden = false
         }
      }
   }

   lowerHigherPageNumbers() {
      const pagesArray = Object.keys(this.scope.loadedPagesMap).map((page) => parseInt(page, 10))
      const lastPage = Math.max(...pagesArray)

      for(let i = this.scope.page + 1; i <= lastPage; i++) {
         if(i in this.scope.loadedPagesMap) {
            this.lowerPageNumber(i)
         }
      }
      if(lastPage != this.scope.page) delete this.scope.loadedPagesMap[lastPage]
   }

   lowerPageNumber(page:number) {
      this.scope.loadedPagesMap[page - 1] = this.scope.loadedPagesMap[page]

      for (let key in this.scope.data) {
         if(this.scope.data[key].page === page) {
            this.scope.data[key].page--
         }
      }
   }

   complementData(data: CourseReserve[], instructorSeparator='<br>') {
      const currentPageCount = Object.keys(this.scope.data)
         .filter((key) => this.scope.data[key].page === this.scope.page).length
      let assignedToCurrentPage = currentPageCount
      let overflowed = false

      data.forEach((courseReserve) => {
         if (!this.scope.data.hasOwnProperty(courseReserve.id)) {
            const combinedInstructors = courseReserve.instructors.map((instructor: any) => instructor.full_name).join(instructorSeparator)
            const displayData: any[] = []
            const fieldMapping = {
               id() { return displayData.push(courseReserve.code) },
               description() { return displayData.push(courseReserve.name) },
               instructor() { return displayData.push(combinedInstructors) },
               section() { return displayData.push(courseReserve.section) }
            }
            this.handleFields(fieldMapping)

            courseReserve.display = displayData
            if (assignedToCurrentPage < this.scope.limit) {
               courseReserve.page = this.scope.page
               courseReserve.hidden = false
               assignedToCurrentPage++
            } else {
               courseReserve.page = this.scope.page + 1
               courseReserve.hidden = true
               overflowed = true
            }
            this.scope.data[courseReserve.id] = courseReserve
         }
      })
      return overflowed
   }

   handleFields(mapping: any) {
      return this.fields.forEach((field: any) => mapping[field]())
   }

   runSearch() {
      this.setDefaultScope()
      return this.get()
   }

   runNewSearch() {
      this.scope.q = ''
      return this.runSearch()
   }

   checkNewSearch() {
      if (this.scope.count === Infinity) {
         return this.setDefaultScope()
      }
   }
}

CourseReserveService.$inject = ['$http', '$timeout', 'configService', 'translationService', 'apiService', 'availabilityService', 'utilitiesService']

angular.module('summonApp.services')
   .service('courseReserveService', CourseReserveService)
